import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-reservation-facility-special',
  templateUrl: './manual-reservation-facility-special.component.html',
  styleUrls: ['./manual-reservation-facility-special.component.css'],
  standalone: false,
})
export class ManualReservationFacilitySpecialComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
